import PrescriptionManual from '@screens/vision/prescription/form/PrescriptionForm'

export default function PrescriptionManualPage() {
  return <PrescriptionManual />
}
